<script setup lang="ts">
const {trackingSessions} = storeToRefs(useTrackingStore());
</script>

<template>
  <div
    v-if="trackingSessions.length > 0"
    class="row mb-sm-2 justify-content-end position-sticky top-2 z-1"
  >
    <div
      v-for="session in trackingSessions"
      :key="session.id"
      class="col-12 col-md-7 col-lg-6 col-xl-5 col-xxl-4"
    >
      <NavbarTrackingSession
        :session="session"
      />
    </div>
  </div>
</template>
